export const hero = ()=> {


    if (document.querySelector('.hero__slider')) {
        const heroSwiperVideo = new Swiper('.swiper-video', {

            slidesPerView: 1,
            effect: 'fade',

            loop: true,

            speed: 400,

            // autoplay: {
            //     delay: 6000,
            // },

            // pagination: {
            //     el: '.hero_slider .swiper-pagination',
            // },
            //
            // navigation: {
            //     nextEl: '.hero__next',
            //     prevEl: '.hero__prev',
            // },
        });
        const heroSwiper = new Swiper('.hero__slider', {

            slidesPerView: 1,
            effect: 'fade',

            loop: true,

            speed: 400,

            autoplay: {
                delay: 6000,
            },

            pagination: {
                el: '.hero_slider .swiper-pagination',
                clickable: true
            },

            navigation: {
                nextEl: '.hero__next',
                prevEl: '.hero__prev',
            },
        });

        heroSwiperVideo.controller.control = heroSwiper;
        heroSwiper.controller.control = heroSwiperVideo;
    }

    document.addEventListener("scroll", () => {

        if (document.querySelector('.hero_video')) {
            const section = document.querySelector(".hero-simple"); // Замініть на клас вашої секції
            const heroPlay = document.querySelector(".hero__play");
            const heroVideo = document.querySelector(".hero-video");

            if (!section || !heroPlay || !heroVideo) return;


            const sectionRect = section.getBoundingClientRect();
            const isOutOfView = sectionRect.bottom < 0 || sectionRect.top > window.innerHeight;

            if (isOutOfView) {
                heroPlay.classList.remove("hidden");
                if (!heroVideo.paused) {
                    heroVideo.pause(); // Зупиняємо відео
                }

            }
        }
    });





}